import React, { useState } from "react";
import { Container, Row, Col, Modal, Image } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Import project images
import tourassist from "../../Assets/Projects/tourassist.png";
import vacation from "../../Assets/Projects/vacation.png";
import microsericesGCP from "../../Assets/Projects/microsericesGCP.png";
import newsAnalysis from "../../Assets/Projects/newsAnalysis.png";
import musicExplore from "../../Assets/Projects/musicExplore.png";
import marketplace from "../../Assets/Projects/marketplace.png";
import omnigpt from "../../Assets/Projects/omnigpt.png";
import prototypeDB from "../../Assets/Projects/prototypeDB.png";
import awsSpringPetClinic from "../../Assets/Projects/awsSpringPetClinic.png"; 
import userManagementRESTAPI from "../../Assets/Projects/userManagementRESTAPI.png"; 
import k8GetAll from "../../Assets/Projects/k8GetAll.png";
import cloudArch from "../../Assets/Projects/cloudArch.png";

function Projects() {
  const [showModal, setShowModal] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);

  const handleImageClick = (img) => {
    setPreviewImg(img);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setPreviewImg(null);
  };

  const renderImageModal = () => (
    <Modal show={showModal} onHide={handleClose} centered size="lg">
      <Modal.Body className="text-center">
        <Image src={previewImg} fluid />
      </Modal.Body>
    </Modal>
  );

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cloudArch}
              onImageClick={() => handleImageClick(cloudArch)}
              isBlog={false}
              title="Cloud Native Task Management App (AWS)"
              description="Cloud Native Task Management App served via CloudFront with an Elastic Beanstalk Java Spring Boot backend exposed by API Gateway. Amazon EventBridge triggers Python Lambda."
              ghLink="https://github.com/snehit221/Cloud-Native-Task-Manager"
              demoLink="https://youtu.be/kqYI2u-pEm8"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={microsericesGCP}
              onImageClick={() => handleImageClick(microsericesGCP)}
              isBlog={false}
              title="CI/CD pipeline with microservices deployed on Kubernetes - GKE, GCP"
              description="Built RESTful microservices, containerized with Docker, deployed to Kubernetes, with a CI/CD pipeline."
              ghLink="https://github.com/snehit221/gcp-microservices-architecture-kubernetes"
              demoLink="https://drive.google.com/file/d/1vrp1W9X-SLxlGjZqsnv22eWPS8admHZu/view"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vacation}
              onImageClick={() => handleImageClick(vacation)}
              isBlog={false}
              title="Vacation Booking Serverless Application (AWS)"
              description="Event driven pub-sub Solution Architecture developed using using Lambda, SNS, SQS, CDK for Terraform used for Infrastructure as Code."
              ghLink="https://github.com/snehit221/aws-dal-vacation"
              demoLink="https://drive.google.com/file/d/1KEuRi_3QvQBgGfG6JARNOTy_FE6Q6wjD/view"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={musicExplore}
              onImageClick={() => handleImageClick(musicExplore)}
              isBlog={false}
              title="Music Explore (AWS)"
              description="Cloud-native Angular & Lambda app using S3, API Gateway, DynamoDB, SNS, SQS, Redis. AWS CloudFormation for IaC."
              ghLink="https://github.com/snehit221/aws-music-explore"
              demoLink="https://drive.google.com/file/d/1PRhCotaE_aTnaTjU5phF7XRMoXBykRIF/view"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={k8GetAll}
              onImageClick={() => handleImageClick(k8GetAll)}
              isBlog={false}
              title="Kubernetes App with Deployment and Secret"
              description="An application demonstrating Kubernetes deployment and secret management."
              ghLink="https://github.com/snehit221/k8-demo"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tourassist}
              onImageClick={() => handleImageClick(tourassist)}
              isBlog={false}
              title="TourAssist"
              description="JWT-secured travel booking app using Java, Spring Boot REST APIs and React frontend."
              ghLink="https://github.com/snehit221/TourAssist-WebApplication"
              demoLink="https://tourassist-frontend.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={awsSpringPetClinic}
              onImageClick={() => handleImageClick(awsSpringPetClinic)}
              isBlog={false}
              title="Spring Pet Clinic (AWS)"
              description="Developed and deployed Solution Architecture on Elastic Beanstalk using S3, VPC, RDS, CloudWatch, CloudFormation; adhering to AWS well-architected framework."
              ghLink="https://github.com/snehit221/aws-java-spring-petclinic"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={marketplace}
              onImageClick={() => handleImageClick(marketplace)}
              isBlog={false}
              title="BidX Marketplace"
              description="Angular + Java Spring Boot platform for buying/selling used products. Hosted on Render."
              ghLink="https://github.com/snehit221/Bidx-web-application?tab=readme-ov-file"
              demoLink="https://main--chimerical-squirrel-737257.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={omnigpt}
              onImageClick={() => handleImageClick(omnigpt)}
              isBlog={false}
              title="OmniGPT Web App"
              description="Unified interface to interact with multiple GPT models. Built with React and Node.js."
              ghLink="https://github.com/snehit221/OmniGPT/tree/main"
              demoLink="https://omnigpt-geeks.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={newsAnalysis}
              onImageClick={() => handleImageClick(newsAnalysis)}
              isBlog={false}
              title="News Data Analysis"
              description="ETL with Java + Spark. MongoDB storage + sentiment analysis using bag-of-words."
              ghLink="https://github.com/snehit221/news-data-unique-frequency-spark"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={prototypeDB}
              onImageClick={() => handleImageClick(prototypeDB)}
              isBlog={false}
              title="RDBMS Prototype implementation with core Java"
              description="Implemented basic SQL-like DB engine in Java with table, CRUD & query support."
              ghLink="https://github.com/snehit221/PrototypeRDBMS"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={userManagementRESTAPI}
              onImageClick={() => handleImageClick(userManagementRESTAPI)}
              isBlog={false}
              title="Java, Spring Boot REST API"
              description="REST API for managing users with CRUD. Containzerized with Docker and deployed on AWS."
              ghLink="https://github.com/snehit221/java-spring-boot-app-with-docker"
            />
          </Col>
        </Row>
        {renderImageModal()}
      </Container>
    </Container>
  );
}

export default Projects;
